import React from "react";
import IndustryPage from "./IndustryPage";

const ITPage: React.FC = () => {
  return <IndustryPage industryKey="it" />;
};

export default ITPage;
